var acc = document.getElementsByClassName("fnFaqAccordion");
var i;
var selected;
var globalMyInterval;
var globalFinalInterval;

document.onload = addClickListenerFnFaqAccordion()

function updateScrollHeight(fnFaqAccordionPanel) {
    fnFaqAccordionPanel.style.maxHeight = fnFaqAccordionPanel.scrollHeight + "px";
}

function cutIntervals(fnFaqAccordionPanel, myInterval, finalInterval) {
    var maxHeight = fnFaqAccordionPanel.style.maxHeight;
    var scrollHeight = fnFaqAccordionPanel.scrollHeight + "px";
    if (maxHeight == scrollHeight) {
        clearInterval(myInterval)
        clearInterval(finalInterval)
    }
}

function toggleFnFaqAccordionPanel(param) {
    // console.log(param)
    if (acc.length > 0 && param) {
        param.classList.toggle("fnFaqAccordionActive");
        var fnFaqAccordionPanel = param.nextElementSibling;
        cutIntervals(fnFaqAccordionPanel, globalMyInterval, globalFinalInterval)
        if (fnFaqAccordionPanel.style.maxHeight) {
            fnFaqAccordionPanel.style.maxHeight = null;
        } else {
            fnFaqAccordionPanel.style.maxHeight = fnFaqAccordionPanel.scrollHeight + "px";
        }
        for (n = 0; n < acc.length; n++) {
            if (fnFaqAccordionPanel !== acc[n].nextElementSibling) {
                acc[n].nextElementSibling.style.maxHeight = null;
                acc[n].classList.remove('fnFaqAccordionActive');
            }
        }

        if (param.classList.contains("fnFaqAccordionActive")) {
            var myInterval = setInterval(function () {
                updateScrollHeight(fnFaqAccordionPanel)
            }, 100)

            var finalInterval = setInterval(function () {
                cutIntervals(fnFaqAccordionPanel, myInterval, finalInterval)
            }, 1000)

            globalMyInterval = myInterval;
            globalFinalInterval = finalInterval;
        }
    }

}

function addClickListenerFnFaqAccordion() {
    for (i = 0; i < acc.length; i++) {
        if (acc.length > 0) {
            if (!acc[i].classList.contains('accordionEventListening')) {
                acc[i].addEventListener("click", function () {
                    let x = this
                    for (a = 0; a < acc.length; a++) {
                        if (x != acc[a]) {
                            acc[a].classList.remove("fnFaqAccordionActive");
                            var fnFaqAccordionPanel = acc[a].nextElementSibling;
                            cutIntervals(fnFaqAccordionPanel, globalMyInterval, globalFinalInterval)
                        }
                    }
                    toggleFnFaqAccordionPanel(this);
                });
            }
            acc[i].classList.add('accordionEventListening')
        }
    }
}